module.exports = __webpack_public_path__ + "img/desain-grafika.aa94f4f0.png";